import React from "react";
import { GOOGLE_API_KEY, CALENDAR_ID } from "../config.js";

import Calendar from 'react_google_calendar'

const calendar_configuration = {
    api_key: GOOGLE_API_KEY,
    calendars: [
      {
        name: 'Complexbjj', // whatever you want to name it
        url: CALENDAR_ID  // your calendar URL
      }
    ],
    dailyRecurrence: 700,
    weeklyRecurrence: 500,
    monthlyRecurrence: 20
}

export default class Upcoming extends React.PureComponent {
    constructor(props) {
      super(props)
        this.state = {
          events: []
        }
    }
    render = () =>
        <Calendar
          events={this.state.events}
          config={calendar_configuration} />

}

